

















































import {
  Component,
  Mixins,
  Vue,
} from 'vue-property-decorator';

import {
  ProductOption,
  ProductVariant,
  ProductVariantOption,
} from '@/models';

import ProductFeature from './ProductFeature';
import ButtonPalettePanel from './palette/ButtonPalettePanel.vue';
import MobileButtonPalettePanel from './palette/MobileButtonPalettePanel.vue';
import MobilePaletteModal from './palette/MobilePaletteModal.vue';

@Component({
  components: {
    ButtonPalettePanel,
    MobileButtonPalettePanel,
    MobilePaletteModal,
  },
})
export default class PaletteFeature extends Mixins(ProductFeature) {
  get product() {
    return this.variant.product;
  }

  get hasVariants() {
    return this.product.variants.length > 1;
  }

  public palettePanelComponent(option: ProductOption) {
    // For mobile, render a big button which opens a fullscreen dialogue to select option.
    if (this.isMobile) {
      return 'mobile-button-palette-panel';
    }

    // If all values in the option have swatch images, use swatch panel.

    // Use dropdown menu if the option has more than 6 values.

    // Otherwise, use button.
    return 'button-palette-panel';
  }
}

